export default __webpack_public_path__ + "static/SectionTwo_02_01@2x-a2a9d7b7562adbb6e6b7d9fc5a3c3f89.png";